import { Component, OnInit } from '@angular/core';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-outdoorevent',
  templateUrl: './outdoorevent.component.html',
  styleUrls: ['./outdoorevent.component.scss']
})
export class OutdooreventComponent implements OnInit {

  constructor() { }
  slideconferenceConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidetestimonialsConfig = {
		dots: true,
		infinite: true,
		arrows:false,
		slidesToShow: 1,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
  ngOnInit() {
    jQuery(".event-conference-btn a.event-contact").click(function(){
      jQuery(".event-contact-section").addClass("ok");
    });
  }

}
